import i18n from '@/utils/i18n';
import React from 'react';
import { ORDER_GUIDE_ROUTES } from '@/navigators/routes';
import { OrderGuideStackParams } from '@/navigators/types';
import { StackScreenProps } from '@react-navigation/stack';
import { VolumePromotionsList } from '@/components/orders/volume-promotions-list';

type Props = StackScreenProps<
  OrderGuideStackParams,
  ORDER_GUIDE_ROUTES.VolumePromotionsList
>;

export const OrderGuideVolumePromotionsListScreen: React.FC<Props> = ({
  navigation,
}) => {
  return (
    <VolumePromotionsList
      headerBackButtonLabel={i18n.t('back_to', { name: i18n.t('order_guide') })}
      onNavigateToDetails={(promotionUUID) => {
        navigation.navigate(ORDER_GUIDE_ROUTES.VolumePromotionDetail, {
          promotionUUID,
        });
      }}
    />
  );
};
